export const RemovalPassedFromList = [
  { id: "client", name: "Agent" },
  { id: "automatic", name: "Automatique" },
  { id: "administrator", name: "Administrateur" },
];

export const RemovalPassedFromLabels: Record<string, string> =
  RemovalPassedFromList.reduce(
    (acc, { id, name }) => ({ ...acc, [id]: name }),
    {}
  );
